export class AllowedSectionTypes {
  certificationSectionAllowed: boolean;
  fileSectionAllowed: boolean;
  fixedFileSectionAllowed: boolean;
  templateSectionAllowed: boolean;

  constructor(certificationSectionAllowed: boolean = true,
              fileSectionAllowed: boolean = true,
              fixedFileSectionAllowed: boolean = true,
              templateSectionAllowed: boolean = true
  ) {
    this.certificationSectionAllowed = certificationSectionAllowed;
    this.fileSectionAllowed = fileSectionAllowed;
    this.fixedFileSectionAllowed = fixedFileSectionAllowed;
    this.templateSectionAllowed = templateSectionAllowed;
  }
}
